import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import ApiMakerTable from "shared/api-maker-table"
import classNames from "classnames"
import ContactPoint from "models/contact-point"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import React from "react"
import useI18n from "i18n-on-steroids/src/use-i18n.mjs"

/** Contact points table for admin contact pages. */
export default memo(shapeComponent(class ComponentsContactPointsTable extends ShapeComponent {
  static defaultProps = {
    adminLayout: false,
    userLayout: false
  }

  static propTypes = {
    adminLayout: PropTypes.bool.isRequired,
    className: PropTypes.string,
    userLayout: PropTypes.bool.isRequired
  }

  /** @returns {void} */
  setup() {
    const {t} = useI18n({namespace: "js.components.contact_points.table"})

    this.t = t
  }

  /** @returns {React.ReactNode} */
  render() {
    const {columns} = this.tt
    const {adminLayout, className, userLayout, ...restProps} = this.props

    return (
      <ApiMakerTable
        className={classNames("components--contact-points--table", className)}
        columns={columns}
        defaultParams={{s: "given_at desc"}}
        modelClass={ContactPoint}
        preloads={["notification_type_action", "notification_type_audit_trigger"]}
        select={{
          ContactPoint: ["createdAt", "description", "expiresAt", "givenAt", "id", "points"],
          NotificationTypeAction: ["id", "name", "translatedActionType"],
          NotificationTypeAuditTrigger: ["auditAction", "auditableType", "id"]
        }}
        {...restProps}
      />
    )
  }

  /** @returns {Array<object>} */
  columns = () => [
    {
      attribute: "id",
      defaultVisible: false,
      sortKey: "id"
    },
    {
      attribute: "points",
      sortKey: "points"
    },
    {
      content: this.titleContent,
      identifier: "title",
      label: "Title",
      sortKey: "notificationTypeActionName"
    },
    {
      content: this.sourceContent,
      identifier: "source",
      label: this.t(".source"),
      sortKey: "description"
    },
    {
      attribute: "givenAt",
      sortKey: "givenAt"
    },
    {
      attribute: "expiresAt",
      sortKey: "expiresAt"
    },
    {
      attribute: "createdAt",
      sortKey: "createdAt"
    }
  ]

  /** @returns {string} */
  titleContent = ({contactPoint}) => contactPoint.notificationTypeAction()?.name() || ""

  /** @returns {string} */
  sourceContent = ({contactPoint}) => {
    if (contactPoint.description()) {
      return contactPoint.description()
    }

    if (contactPoint.notificationTypeAction()) {
      return this.t(".from_notification_action", {actionType: contactPoint.notificationTypeAction().translatedActionType()})
    }

    if (contactPoint.notificationTypeAuditTrigger()) {
      return this.t(".from_audit_trigger", {
        auditAction: contactPoint.notificationTypeAuditTrigger().auditAction(),
        auditableType: contactPoint.notificationTypeAuditTrigger().auditableType()
      })
    }

    return this.t(".automatic_registration")
  }
}))
